import React, { useEffect, useState } from "react";
import { LogoStyled } from "./styles/Styled";
import { getSdk } from "../../services/sdkService";

const logos = ["2x.png", "3x.png", "4x.png"];
const resolutions = [1920, 4096, 8192];

export default ({ width, height }) => {
  const [isOnPS4, setIsOnPS4] = useState(null);
  let renderLogo =
    window.innerWidth <= resolutions[0]
      ? logos[0]
      : resolutions[0] <= window.innerWidth <= resolutions[1]
      ? logos[1]
      : resolutions[1] >= window.innerWidth
      ? logos[2]
      : logos[1];

  useEffect(() => {
    async function fetchData() {
      const getPlatform = await getSdk().systemManager.device.getPlatform();
      setIsOnPS4(getPlatform === "ps4" ? true : false);
    }
    fetchData();
  }, []);

  return isOnPS4 ? (
    <LogoStyled src={`/images/1x.png`} alt="Logo" width={width} height={height} />
  ) : (
    <LogoStyled src={`/images/${renderLogo}`} alt="Logo" width={width} height={height} />
  );
};
